import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const CloseThin = (props) => (
  <Icon viewBox="-2.4 21.6 9.7 9.7" {...props}>
    <g>
      <title>close</title>
      <path d="M7.3 22.4l-.7-.8-4.1 4.2-4.1-4.2-.8.8 4.2 4.1-4.2 4.1.8.7 4.1-4.1 4.1 4.1.7-.7-4.1-4.1z" className="st0" />
    </g>
  </Icon>
);
/*eslint-enable */

export default CloseThin;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/CloseThin.js